import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  cancelSubStepApproval,
  getWorkflowCase,
  listWorkflowCases,
} from '@ebalance/proto/bffuser/v1/workflow_case_service-WorkflowCaseService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * サブステップ承認を取消する mutation hook。
 * onSuccess で detail + list query を invalidate する。
 */
export function useCancelSubStepApproval(
  caseId: string,
): InvalidatingMutationResultFor<typeof cancelSubStepApproval> {
  return useInvalidatingMutation(cancelSubStepApproval, [
    createConnectQueryKey({
      schema: getWorkflowCase,
      cardinality: 'finite',
      input: { id: caseId },
    }),
    createConnectQueryKey({ schema: listWorkflowCases, cardinality: 'finite' }),
  ])
}
